import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import FadeInSection from '../FadeInSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import './index.scss'

const Contact = () => {
  const form = useRef()

  const sendEmail = (e) => {
    e.preventDefault()
    emailjs
      .sendForm(
        'service_ss5icmb',
        'template_szlowzi',
        form.current,
        'uTaXSYV0UqDjtX7mh'
      )
      .then(
        () => {
          alert('Message sent successfully!')
          e.target.reset()
        },
        () => {
          alert('Failed to send. Please try again or email me directly.')
        }
      )
  }

  return (
    <section id="contact" className="contact-section">
      <FadeInSection>
        <div className="section-header">
          <span className="section-title">/ contact</span>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3 className="contact-cta">Get In Touch</h3>
            <p className="contact-blurb">
              Whether you have a question, a project idea, or just want to say
              hi — my inbox is always open. I'll get back to you as soon as
              possible!
            </p>
            <ul className="contact-details">
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href="mailto:akshata.dhuraji@gmail.com">
                  akshata.dhuraji@gmail.com
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faLocationDot} className="contact-icon" />
                <span>Singapore</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faLinkedin} className="contact-icon" />
                <a
                  href="https://www.linkedin.com/in/akshatadhuraji/"
                  target="_blank"
                  rel="noreferrer"
                >
                  linkedin.com/in/akshatadhuraji
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faGithub} className="contact-icon" />
                <a
                  href="https://github.com/akshataxx"
                  target="_blank"
                  rel="noreferrer"
                >
                  github.com/akshataxx
                </a>
              </li>
            </ul>
          </div>

          <div className="contact-form-wrap">
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <div className="form-row">
                <input placeholder="Name" type="text" name="name" required />
                <input placeholder="Email" type="email" name="email" required />
              </div>
              <input placeholder="Subject" type="text" name="subject" required />
              <textarea
                placeholder="Message"
                name="message"
                required
              />
              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </FadeInSection>

      <footer className="site-footer">
        <p>Designed &amp; built by Akshata Dhuraji</p>
      </footer>
    </section>
  )
}

export default Contact
